document.addEventListener("DOMContentLoaded", () => {
  const cleanupCallbacks = [];
  const addCleanup = (callback) => {
    if (typeof callback === "function") {
      cleanupCallbacks.push(callback);
    }
  };

  //lazy load videos
  const videos = document.querySelectorAll(".lazy-video");
  const isMobile = () => window.innerWidth <= 750;

  const setupVideo = (video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;

    video.setAttribute("muted", "");
    video.setAttribute("autoplay", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
  };

  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (!video.dataset.src) return;

        const isMobileVideo = video.classList.contains("Mobile_video_new");
        const isDesktopVideo = video.classList.contains("Desktop_video_new");

        setupVideo(video);

        if ((isMobile() && isDesktopVideo) || (!isMobile() && isMobileVideo)) {
          video.pause();
          return;
        }

        if (!video.dataset.loaded) {
          video.src = video.dataset.src;
          video.load();
          video.dataset.loaded = "true";
        }

        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          requestAnimationFrame(() => {
            const promise = video.play();

            if (promise) {
              promise.catch(() => {
                video.muted = true;

                setTimeout(() => {
                  video.play().catch(() => { });
                }, 50);
              });
            }
          });
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    },
    {
      threshold: [0.6],
      rootMargin: "200px",
    }
  );

  videos.forEach((video) => {
    setupVideo(video);
    videoObserver.observe(video);
  });

  addCleanup(() => {
    videoObserver.disconnect();
  });

  //footer form

  const formSelector = ".Footer_innerside_innerright_forms_new";

  if (formSelector) {
    const formObserver = new MutationObserver(() => {
      const form = document.querySelector(formSelector);
      if (!form) return;

      const emailInput = form.querySelector('input[type="email"]');
      if (!emailInput) return;

      const handleEmailInput = function () {
        this.classList.toggle("typing", this.value.trim() !== "");
      };

      emailInput.addEventListener("input", handleEmailInput, { passive: true });
      addCleanup(() => {
        emailInput.removeEventListener("input", handleEmailInput, { passive: true });
      });
      formObserver.disconnect();
    });

    formObserver.observe(document.body, { childList: true, subtree: true });
    addCleanup(() => {
      formObserver.disconnect();
    });
  }


  //size guide dialog box
  const isSizeGuideMobile = () => window.matchMedia("(max-width: 749px)").matches;

  const setSizeGuideVisualHeight = (component) => {
    if (!component) return;

    const panels = [...component.querySelectorAll("[data-size-guide-panel]")];

    if (!isSizeGuideMobile()) {
      panels.forEach((panel) => {
        panel.querySelector(".pdp-size-guide__visual")?.style.removeProperty("--size-guide-mobile-visual-height");
      });
      return;
    }

    let tallestVisualHeight = 0;

    panels.forEach((panel) => {
      const visual = panel.querySelector(".pdp-size-guide__visual");
      if (!visual) return;

      const wasHidden = panel.classList.contains("hidden");
      const previousPanelStyle = {
        display: panel.style.display,
        position: panel.style.position,
        visibility: panel.style.visibility,
        pointerEvents: panel.style.pointerEvents,
        width: panel.style.width,
      };
      const previousVisualHeight = visual.style.height;

      if (wasHidden) {
        panel.classList.remove("hidden");
        panel.style.position = "absolute";
        panel.style.visibility = "hidden";
        panel.style.pointerEvents = "none";
        panel.style.width = "100%";
      }

      visual.style.height = "auto";
      tallestVisualHeight = Math.max(tallestVisualHeight, Math.ceil(visual.getBoundingClientRect().height));
      visual.style.height = previousVisualHeight;

      if (wasHidden) {
        panel.classList.add("hidden");
        panel.style.display = previousPanelStyle.display;
        panel.style.position = previousPanelStyle.position;
        panel.style.visibility = previousPanelStyle.visibility;
        panel.style.pointerEvents = previousPanelStyle.pointerEvents;
        panel.style.width = previousPanelStyle.width;
      }
    });

    if (!tallestVisualHeight) return;

    panels.forEach((panel) => {
      panel
        .querySelector(".pdp-size-guide__visual")
        ?.style.setProperty("--size-guide-mobile-visual-height", `${tallestVisualHeight}px`);
    });
  };

  const setAllSizeGuideVisualHeights = (root = document) => {
    root.querySelectorAll("[data-size-guide-drawer]").forEach(setSizeGuideVisualHeight);
  };

  const initSizeGuideVisualHeights = (root = document) => {
    root.querySelectorAll("[data-size-guide-drawer]").forEach((component) => {
      if (component.dataset.sizeGuideVisualHeightInitialized === "true") return;
      component.dataset.sizeGuideVisualHeightInitialized = "true";

      component.querySelectorAll(".pdp-size-guide__visual img").forEach((image) => {
        if (image.complete) return;
        image.addEventListener("load", () => setSizeGuideVisualHeight(component), { once: true });
      });

      setSizeGuideVisualHeight(component);
    });
  };

  const initSizeGuideDrawerAnimation = (root = document) => {
    root.querySelectorAll("[data-size-guide-drawer]").forEach((component) => {
      if (component.dataset.sizeGuideAnimationInitialized === "true") return;
      component.dataset.sizeGuideAnimationInitialized = "true";

      component.addEventListener("dialog:open", () => {
        const dialog = component.querySelector(".pdp-size-guide__drawer");
        if (!dialog) return;

        dialog.classList.remove("pdp-size-guide__drawer--opened");

        requestAnimationFrame(() => {
          setSizeGuideVisualHeight(component);
          requestAnimationFrame(() => {
            setSizeGuideVisualHeight(component);
            if (dialog.hasAttribute("open") && !dialog.classList.contains("dialog-closing")) {
              dialog.classList.add("pdp-size-guide__drawer--opened");
            }
          });
        });
      });

      component.addEventListener("dialog:close", () => {
        component.querySelector(".pdp-size-guide__drawer")?.classList.remove("pdp-size-guide__drawer--opened");
      });
    });
  };

  const initAccordionMediaDialogLock = (root = document) => {
    root.querySelectorAll(".accordion_media_dialog").forEach((component) => {
      if (component.dataset.accordionMediaLockInitialized === "true") return;
      component.dataset.accordionMediaLockInitialized = "true";

      component.addEventListener("dialog:open", () => {
        document.body.classList.add("accordion-media-dialog-open");
      });

      component.addEventListener("dialog:close", () => {
        document.body.classList.remove("accordion-media-dialog-open");
      });
    });
  };

  initSizeGuideVisualHeights();
  initSizeGuideDrawerAnimation();
  initAccordionMediaDialogLock();

  const handleSectionLoad = (event) => {
    initSizeGuideVisualHeights(event.target);
    initSizeGuideDrawerAnimation(event.target);
    initAccordionMediaDialogLock(event.target);
  };

  let resizeFrameId = null;
  const handleResize = () => {
    if (resizeFrameId !== null) return;

    resizeFrameId = window.requestAnimationFrame(() => {
      resizeFrameId = null;
      setAllSizeGuideVisualHeights();
    });
  };

  const handleDocumentClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest("[data-size-guide-tab], [data-size-guide-unit]");
    if (!button) return;

    const drawer = button.closest("[data-size-guide-drawer]");
    if (!drawer) return;

    if (button.matches("[data-size-guide-tab]")) {
      const targetIndex = button.dataset.sizeGuideTab;

      drawer.querySelectorAll("[data-size-guide-tab]").forEach((tab) => {
        tab.classList.toggle("is-active", tab.dataset.sizeGuideTab === targetIndex);
      });

      drawer.querySelectorAll("[data-size-guide-panel]").forEach((panel) => {
        panel.classList.toggle("hidden", panel.dataset.sizeGuidePanel !== targetIndex);
      });

      drawer.querySelectorAll("[data-size-guide-intro]").forEach((intro) => {
        intro.classList.toggle("hidden", intro.dataset.sizeGuideIntro !== targetIndex);
      });

      button.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });

      window.requestAnimationFrame(() => setSizeGuideVisualHeight(drawer));
    }

    if (button.matches("[data-size-guide-unit]")) {
      const targetUnit = button.dataset.sizeGuideUnit;

      drawer.querySelectorAll("[data-size-guide-unit]").forEach((tab) => {
        tab.classList.toggle("is-active", tab.dataset.sizeGuideUnit === targetUnit);
      });

      drawer.querySelectorAll("[data-size-guide-unit-content]").forEach((content) => {
        content.classList.toggle("hidden", content.dataset.sizeGuideUnitContent !== targetUnit);
      });

      window.requestAnimationFrame(() => setSizeGuideVisualHeight(drawer));
    }

  };

  document.addEventListener("shopify:section:load", handleSectionLoad);
  window.addEventListener("resize", handleResize, { passive: true });
  document.addEventListener("click", handleDocumentClick);

  addCleanup(() => {
    if (resizeFrameId !== null) {
      window.cancelAnimationFrame(resizeFrameId);
    }
    document.removeEventListener("shopify:section:load", handleSectionLoad);
    window.removeEventListener("resize", handleResize, { passive: true });
    document.removeEventListener("click", handleDocumentClick);
  });

  const cleanup = () => {
    cleanupCallbacks.forEach((callback) => callback());
    cleanupCallbacks.length = 0;
    window.removeEventListener("pagehide", cleanup);
  };

  window.addEventListener("pagehide", cleanup, { once: true, passive: true });

  // global accordion js
  function globalFaqSlideUp(element, duration = 300) {
    element.style.height = element.scrollHeight + "px";
    element.offsetHeight;
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = "0px";
    element.style.overflow = "hidden";

    setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  }

  function globalFaqSlideDown(element, duration = 300) {
    element.style.display = "block";
    const height = element.scrollHeight;
    element.style.height = "0px";
    element.style.overflow = "hidden";
    element.offsetHeight;
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = `${height}px`;

    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  }

  function initGlobalFaqAccordion(root) {
    const scope = root || document;

    scope.querySelectorAll(".global-faq-section .accordion").forEach((accordion) => {
      const items = accordion.querySelectorAll("li");

      items.forEach((item) => {
        if (item.dataset.globalFaqBound === "true") return;
        item.dataset.globalFaqBound = "true";

        const question = item.querySelector(".question");
        const answer = item.querySelector(".answer");
        if (!question || !answer) return;

        answer.style.display = item.classList.contains("open") ? "block" : "none";

        question.addEventListener("click", () => {
          const isOpen = item.classList.contains("open");

          items.forEach((otherItem) => {
            if (otherItem === item) return;
            otherItem.classList.remove("open");
            const otherAnswer = otherItem.querySelector(".answer");
            if (otherAnswer && otherAnswer.style.display !== "none") {
              globalFaqSlideUp(otherAnswer, 300);
            }
          });

          if (isOpen) {
            item.classList.remove("open");
            globalFaqSlideUp(answer, 300);
          } else {
            item.classList.add("open");
            globalFaqSlideDown(answer, 300);
          }
        });
      });
    });
  }

  window.initGlobalFaqAccordion = initGlobalFaqAccordion;
  initGlobalFaqAccordion(document);


});
